import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { InputProps } from '~/core/dto/components/inputDTO';

import './Input.styles.css';

const Input = forwardRef<HTMLInputElement, InputProps>( ( {
  icon, className, error, ...props
}, ref ) => {

  const inputRef = useRef<HTMLInputElement>( null );

  useImperativeHandle( ref, () => inputRef.current ?? ( {} as HTMLInputElement ), [] );

  return (
    <>
      <div
        className={`inputContainer${error ? ' error' : ''} ${className ?? ''}`}
        onClick={() => inputRef.current?.focus()}
        aria-hidden
      >
        <img src={icon} alt="" />
        <input ref={inputRef} {...props} />
      </div>
      {error && <p className="errorText">{error}</p>}
    </>
  );

} );

export default Input;
